export class StatisticsModel {
    //public date: Date;
    public domainLink: string;
    public groupName: string;
    public countSub: number;
    public countUnSub: number;
    public minSubId: number;
    public countSent: number;
    public countDelivered: number;
    public countOpened: number;
    public profit: number;
    public dateSend: string;
    public notifId: string;
}



// WEBPACK FOOTER //
// ./src/app/core/models/statistics.model.ts